import AlternativeFund from '../templates/AlternativeFund';
import AreaOfExpertisePage from '../templates/AreaOfExpertisePage';
import InsightPage from '../templates/InsightPage';
import LandingPage from '../templates/LandingPage';
import LegalDocumentationPage from '../templates/LegalDocumentationPage';
import MutualFund from '../templates/MutualFund';
import Page from '../templates/Page';
import ServicePage from '../templates/ServicePage';

export const pageTemplatesByPath = {
  './src/templates/Page.tsx': Page,
  './src/templates/InsightPage.tsx': InsightPage,
  './src/templates/MutualFund.tsx': MutualFund,
  './src/templates/AlternativeFund.tsx': AlternativeFund,
  './src/templates/LegalDocumentationPage.tsx': LegalDocumentationPage,
  './src/templates/AreaOfExpertisePage.tsx': AreaOfExpertisePage,
  './src/templates/ServicePage.tsx': ServicePage,
  './src/templates/LandingPage.tsx': LandingPage,
};
